<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Top Bar, show/hide overlays-->
				<div class="TopBar">
					<!--Buttons-->
					<div>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onDeselect()">Deselect All</button>
						<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
						<button
							style="margin-left: 5px"
							[ngClass]="{
								btn: true,
								'btn-success': PlaySounds == true,
								'btn-danger': PlaySounds == false
							}"
							(click)="onPlaySoundsClick()"
						>
							<i *ngIf="PlaySounds == true" class="fa fa-volume-up" aria-hidden="true"></i>
							<i *ngIf="PlaySounds == false" class="fa fa-volume-off" aria-hidden="true"></i>
							{{ PlaySounds == true ? " (Enabled)" : " (Disabled)" }}
						</button>
					</div>

					<!--Info-->
					<div *ngIf="ShowInfo == true" style="margin-top: 10px; margin-bottom: 15px"></div>

					<!--Overlays, Labels, etc.-->
					<div class="OptionsFlex">
						<!--Overlays-->
						<div class="OptionsBorder">
							<h5>Overlays:</h5>

							<div class="OptionGrid">
								<div>
									<label>Bus Positions</label>
									<div class="BusOptionGrid">
										<label for="ShowAllBuses">Show Buses:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowAllBuses"
											type="checkbox"
											[(ngModel)]="ShowAllBuses"
											(ngModelChange)="onShowAllBusChange($event)"
										/>

										<label>Show Buses From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSchoolOptionID"
											[(ngModel)]="BusSchoolOptionID"
											(ngModelChange)="onBusSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstBusSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="BusSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="BusSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="BusSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onBusSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="BusSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ BusSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>

										<label>Severity:</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSeverityOption"
											[(ngModel)]="BusSeverityOption"
											(ngModelChange)="onBusSeverityOptionChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstSeverity" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Positions</label>
									<div class="StudentOptionGrid">
										<label for="StudentSwipeOn">Student Gets On Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentSwipeOn"
											type="checkbox"
											[(ngModel)]="StudentSwipeOn"
											(ngModelChange)="onStudentSwipeOnChange($event)"
										/>

										<label for="StudentSwipeOff">Student Gets Off Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentSwipeOff"
											type="checkbox"
											[(ngModel)]="StudentSwipeOff"
											(ngModelChange)="onStudentSwipeOffChange($event)"
										/>

										<label for="StudentShowLastTransactionOnly">Last Transaction Only:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentShowLastTransactionOnly"
											type="checkbox"
											[(ngModel)]="StudentShowLastTransactionOnly"
											(ngModelChange)="onStudentShowLastTransactionOnlyChange($event)"
										/>

										<!-- <label style="color: Red;">Spiderfy distance TESTING:</label> -->
										<!-- <input [(ngModel)]="Tolerance" type="number" min="0"> -->

										<!-- <label style="color: Red;">DEBUG Spiderfy length:</label>
                                        <input [(ngModel)]="ZoomCoefficient" type="number" min="0" step="0.001"> -->

										<!-- <label>Zoom Level</label>
                                        <label>{{DebugGetZoom()}}</label> -->

										<label>Show Students From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="StudentSchoolOptionID"
											[(ngModel)]="StudentSchoolOptionID"
											(ngModelChange)="onStudentSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstStudentSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="StudentSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="StudentSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="StudentSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onStudentSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="StudentSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ StudentSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Geo Fences</label>
									<div class="StudentOptionGrid">
										<label for="ShowGeoFences">Show Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowGeoFences"
											type="checkbox"
											[(ngModel)]="ShowGeoFences"
											(ngModelChange)="onShowGeoFencesChange($event)"
										/>

										<label for="HideInactiveGeoFences">Hide Inactive Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideInactiveGeoFences"
											type="checkbox"
											[(ngModel)]="HideInactiveGeoFences"
											(ngModelChange)="onHideInactiveGeoFencesChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<div class="MiscOptionGrid">
										<label style="color: Red" for="HideUnselect">Hide Unselected</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideUnselect"
											type="checkbox"
											[(ngModel)]="HideUnselect"
											(ngModelChange)="onHideUnselectChange($event)"
										/>

										<label for="ShowTraffic">Show Traffic</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowTraffic"
											type="checkbox"
											[(ngModel)]="ShowTraffic"
											(ngModelChange)="onShowTrafficChange($event)"
										/>

										<label>Refresh Seconds:</label>
										<input class="TextWidth" type="number" [min]="MinimumRefreshSeconds" [(ngModel)]="RefreshMapSeconds" />
									</div>
								</div>
							</div>
						</div>

						<!--Label Options-->
						<div class="OptionsFlexItem OptionsBorder">
							<h5>Labels:</h5>

							<div class="OptionGrid">
								<div>
									<label>Bus Labels</label>
									<div class="BusLabelOptionGrid">
										<label for="ShowBusNumber">Bus Number</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusNumber"
											type="checkbox"
											[(ngModel)]="ShowBusNumber"
											(ngModelChange)="onShowBusNumberChange($event)"
										/>

										<label class="BusLabelMiddleColumn" for="ShowAlert">Alert Description</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowAlert"
											type="checkbox"
											[(ngModel)]="ShowAlert"
											(ngModelChange)="onShowAlertChange($event)"
										/>

										<label for="ShowStudentCount">Student Count</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentCount"
											type="checkbox"
											[(ngModel)]="ShowStudentCount"
											(ngModelChange)="onShowStudentCountChange($event)"
										/>

										<label class="BusLabelMiddleColumn" for="ShowSpeed">Speed</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowSpeed"
											type="checkbox"
											[(ngModel)]="ShowSpeed"
											(ngModelChange)="onShowSpeedChange($event)"
										/>

										<label for="ShowBusScanTime">Last Updated</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusScanTime"
											type="checkbox"
											[(ngModel)]="ShowBusScanTime"
											(ngModelChange)="onShowBusScanTimeChange($event)"
										/>

										<label class="BusLabelMiddleColumn">Speed Alert Mph:</label>
										<input
											[disabled]="IsLoading() == true"
											class="TextWidth"
											type="number"
											[min]="0"
											[(ngModel)]="SpeedAlertMph"
											(ngModelChange)="onSpeedAlertMphChange($event)"
										/>

										<label [style.color]="BusTextColor">Bus Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="BusTextColor"
												(ngModelChange)="onBusTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetBusLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Labels</label>
									<div class="BusLabelOptionGrid">
										<label for="ShowStudentName">Student Name</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentName"
											type="checkbox"
											[(ngModel)]="ShowStudentName"
											(ngModelChange)="onShowStudentNameChange($event)"
										/>

										<label class="BusLabelMiddleColumn" for="ShowStudentID">Student ID</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentID"
											type="checkbox"
											[(ngModel)]="ShowStudentID"
											(ngModelChange)="onShowStudentIDChange($event)"
										/>

										<label for="ShowStudentBus">Bus Entered or Exited</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentBus"
											(ngModelChange)="onShowStudentBusChange($event)"
										/>

										<label class="BusLabelMiddleColumn" for="ShowStudentCurrentBus">Current Bus (if any)</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentCurrentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentCurrentBus"
											(ngModelChange)="onShowStudentCurrentBusChange($event)"
										/>

										<label for="ShowStudentScanTime">Scan Time</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentScanTime"
											type="checkbox"
											[(ngModel)]="ShowStudentScanTime"
											(ngModelChange)="onShowStudentScanTimeChange($event)"
										/>

										<label class="BusLabelMiddleColumn" for="ShowScheduledRider">Scheduled Rider</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowScheduledRider"
											type="checkbox"
											[(ngModel)]="ShowScheduledRider"
											(ngModelChange)="onShowScheduledRiderChange($event)"
										/>

										<label [style.color]="StudentTextColor">Student Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="StudentTextColor"
												(ngModelChange)="onStudentTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetStudentLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="OptionsBorder TopMargin">
						<h5>Debug Options</h5>

						<div class="DebugGrid">
							<div>
								<label>Move Bus Position Options</label>

								<div class="BusOptionGrid">
									<label>Speed:</label>
									<input type="number" [disabled]="IsLoading() == true" [(ngModel)]="UpdateBusSpeedMph" min="0" />

									<label>Date:</label>
									<p-calendar
										[disabled]="IsLoading() == true"
										showIcon="true"
										showButtonBar="true"
										showTime="true"
										[hourFormat]="12"
										[(ngModel)]="UpdateBusDate"
										name="UpdateBusDate"
									></p-calendar>
								</div>
							</div>

							<div class="VerticalBorder"></div>

							<div>
								<label>Move Student Position Options</label>

								<div class="BusOptionGrid">
									<label>Date:</label>
									<p-calendar
										[disabled]="IsLoading() == true"
										showIcon="true"
										showButtonBar="true"
										showTime="true"
										[hourFormat]="12"
										[(ngModel)]="UpdateStudentDate"
										name="UpdateStudentDate"
									></p-calendar>
								</div>
							</div>

							<div class="VerticalBorder"></div>

							<div>
								<label>Create Data Options</label>

								<div class="DebugCreateGrid">
									<label>Create Type:</label>
									<select [disabled]="IsLoading() == true" class="form-control" name="CreateTypeID" [(ngModel)]="CreateTypeID">
										<option value="" style="display: none"></option>
										<option *ngFor="let o of lstCreateType" [ngValue]="o.ID">
											{{ o.Desc }}
										</option>
									</select>

									<!--Bus-->
									<label class="BusLabelMiddleColumn" *ngIf="CreateTypeID == 1">Bus:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 1"
										[disabled]="IsLoading() == true"
										[options]="lstCreateBuses"
										[(ngModel)]="CreateBus"
										optionLabel="BusFullDesc"
										[filter]="true"
										filterBy="BusFullDesc"
										[showClear]="false"
										placeholder="Select a Bus"
										(ngModelChange)="onCreateBusChange($event)"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateBus">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateBus.BusFullDesc }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.BusFullDesc }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label *ngIf="CreateTypeID == 1">Route:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 1"
										[disabled]="IsLoading() == true"
										[options]="lstCreateBusRoutes"
										[(ngModel)]="CreateBusRoute"
										optionLabel="BusRouteFullDesc"
										[filter]="true"
										filterBy="BusRouteFullDesc"
										[showClear]="false"
										placeholder="Select a Route"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateBusRoute">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateBusRoute.BusRouteFullDesc }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.BusRouteFullDesc }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label class="BusLabelMiddleColumn" *ngIf="CreateTypeID == 1">Driver:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 1"
										[disabled]="IsLoading() == true"
										[options]="lstCreateUsers"
										[(ngModel)]="CreateBusUser"
										optionLabel="PersonName"
										[filter]="true"
										filterBy="PersonName"
										[showClear]="false"
										placeholder="Select a Driver"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateBusUser">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateBusUser.PersonName }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.PersonName }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label *ngIf="CreateTypeID == 1">Speed:</label>
									<input *ngIf="CreateTypeID == 1" type="number" [disabled]="IsLoading() == true" [(ngModel)]="CreateBusSpeedMph" min="0" />

									<label *ngIf="CreateTypeID == 1" class="BusLabelMiddleColumn">Date:</label>
									<p-calendar
										*ngIf="CreateTypeID == 1"
										[disabled]="IsLoading() == true"
										showIcon="true"
										showButtonBar="true"
										showTime="true"
										[hourFormat]="12"
										[(ngModel)]="CreateBusDate"
										name="CreateBusDate"
									></p-calendar>

									<label>Accuracy:</label>
									<input type="number" [disabled]="IsLoading() == true" [(ngModel)]="HorizontalAccuracy" min="0" />

									<!--Student-->
									<label class="BusLabelMiddleColumn" *ngIf="CreateTypeID == 2">Entry Type:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										[options]="lstCreateStudentEntryType"
										[(ngModel)]="CreateStudentEntryType"
										optionLabel="EntryTypeDesc"
										[filter]="true"
										filterBy="EntryTypeDesc"
										[showClear]="false"
										placeholder="Select Enter or Exit"
										(ngModelChange)="onCreateStudentEntryTypeChange($event)"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateStudentEntryType">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateStudentEntryType.EntryTypeDesc }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.EntryTypeDesc }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label *ngIf="CreateTypeID == 2">Bus:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										[options]="lstCreateStudentBuses"
										[(ngModel)]="CreateStudentBus"
										optionLabel="BusFullDesc"
										[filter]="true"
										filterBy="BusFullDesc"
										[showClear]="false"
										placeholder="Select a Bus"
										(ngModelChange)="onCreateStudentBusChange($event)"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateStudentBus">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateStudentBus.BusFullDesc }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.BusFullDesc }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label class="BusLabelMiddleColumn" *ngIf="CreateTypeID == 2">Route:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										[options]="lstCreateStudentBusRoute"
										[(ngModel)]="CreateStudentBusRoute"
										optionLabel="BusRouteFullDesc"
										[filter]="true"
										filterBy="BusRouteFullDesc"
										[showClear]="false"
										placeholder="Select a Route"
										(ngModelChange)="onCreateStudentRouteChange($event)"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateStudentBusRoute">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateStudentBusRoute.BusRouteFullDesc }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.BusRouteFullDesc }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label *ngIf="CreateTypeID == 2">Student:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										[options]="lstCreateStudents"
										[(ngModel)]="CreateStudentStudent"
										optionLabel="PersonFullName"
										[filter]="true"
										filterBy="PersonFullName"
										[showClear]="false"
										placeholder="Select a Student"
										[virtualScroll]="true"
										[virtualScrollItemSize]="30"
										[style.Color]="CreateStudentStudent.IsScheduled == true ? 'Black' : 'Red'"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateStudentStudent">
												<div
													class="form-control NoBorder"
													style="text-align: left"
													[style.Color]="CreateStudentStudent.IsScheduled == true ? 'Black' : 'Red'"
												>
													{{ CreateStudentStudent.PersonFullName }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div
													class="form-control NoBorder"
													style="text-align: left"
													[style.Color]="BusItem.IsScheduled == true ? 'Black' : 'Red'"
												>
													{{ BusItem.PersonFullName }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label class="BusLabelMiddleColumn" *ngIf="CreateTypeID == 2">Driver:</label>
									<p-dropdown
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										[options]="lstCreateStudentDrivers"
										[(ngModel)]="CreateStudentDriver"
										optionLabel="PersonName"
										[filter]="true"
										filterBy="PersonName"
										[showClear]="false"
										placeholder="Select a Driver"
									>
										<ng-template pTemplate="selectedItem">
											<div *ngIf="CreateStudentDriver">
												<div class="form-control NoBorder" style="text-align: left">
													{{ CreateStudentDriver.PersonName }}
												</div>
											</div>
										</ng-template>
										<ng-template let-BusItem pTemplate="item">
											<div>
												<div class="form-control NoBorder" style="text-align: left">
													{{ BusItem.PersonName }}
												</div>
											</div>
										</ng-template>
									</p-dropdown>

									<label *ngIf="CreateTypeID == 2">Date:</label>
									<p-calendar
										*ngIf="CreateTypeID == 2"
										[disabled]="IsLoading() == true"
										showIcon="true"
										showButtonBar="true"
										showTime="true"
										[hourFormat]="12"
										[(ngModel)]="CreateStudentDate"
										name="CreateStudentDate"
									></p-calendar>
								</div>

								<div>
									<button
										[ngClass]="{
											btn: true,
											'btn-success': DebugCreating == false,
											'btn-danger': DebugCreating == true
										}"
										(click)="onDebugCreatingClick()"
										style="margin-top: 10px"
									>
										<i *ngIf="DebugCreating == false" class="fa fa-plus" aria-hidden="true"></i>
										<i *ngIf="DebugCreating == true" class="fa fa-times" aria-hidden="true"></i>
									</button>
								</div>
							</div>

							<div class="VerticalBorder"></div>

							<div>
								<label>Delete Data Options</label>
								<div style="margin-top: 5px">
									<button
										[ngClass]="{
											btn: true,
											'btn-warning': DebugDeleting == false,
											'btn-danger': DebugDeleting == true
										}"
										(click)="onDebugDeletingClick()"
									>
										<i *ngIf="DebugDeleting == false" class="fa fa-trash-o" aria-hidden="true"></i>
										<i *ngIf="DebugDeleting == true" class="fa fa-times" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					[ngClass]="{
						MapGridOneCol: ShowSideBar == false,
						MapGridTwoCol: ShowSideBar == true
					}"
				>
					<p-gmap
						*ngIf="ShowMap == true"
						[overlays]="overlays"
						[options]="options"
						[style]="{ width: '100%', height: '625px' }"
						(onMapClick)="handleMapClick($event)"
						(onOverlayClick)="handleOverlayClick($event)"
						(onOverlayDragEnd)="onOverlayDragEnd($event)"
					></p-gmap>

					<!--Side Bar for searching for buses or students-->
					<div *ngIf="ShowSideBar == true">
						<caass-bus-selector (SelectedChanged)="onSelectBusesOnMap($event)"> </caass-bus-selector>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
